/**
 * 导航栏用户图标
 */
// 图标
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
// antd 组件
import { Avatar, Dropdown } from 'antd';
//
import { NavLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
//
import { useSelector, useDispatch } from 'react-redux';
import { setLoginStateFalse, setLoginStamp } from '@/plugin/slice/loginStateSlice.js';
// 
import { get_LS_Item } from '@/plugin/tools/tools';
//

//////////////// 
export default function UserAvatar() {
  const loginState = useSelector((state) => state.loginState.loginState)
  // const dispatch = useDispatch();
  const navigate = useNavigate();
  // 下拉菜单 数据
  const items = [
    { key: '1', label: <AuthStatus />, icon: <UserOutlined />, },
    { type: 'divider' },  // 分隔行
    loginState ? { key: '2', label: <Logout />, icon: <LogoutOutlined /> } : null
  ];
  //////////////
  return (
    <div id='area'>
      <Dropdown
        menu={{
          items,      // 条目
          // onClick, // 直接点击出发指定条目
          forceSubMenuRender: true  // 在子菜单展示之前就渲染进 DOM
        }}
        arrow={{ pointAtCenter: true }}     // 下拉菜单有小箭头
        placement="bottomRight"            // 下拉菜单出现位置
        // getPopupContainer={() => document.getElementById('area')}
        forceRender={true} 
        
      >
        <Avatar className=''
          size={25}
          icon={<UserOutlined />}
          shape='square'
          // 判断是否已经登录，点击事件，是登录还是跳转用户页面
          onClick={get_LS_Item('account_name') ? () => navigate('/userinfo') : () => navigate('/login')}
        />
      </Dropdown>
      {/* <button onClick={() => dispatch(setLoginStateTrue())}>t</button> */}
      {/* <button onClick={() => dispatch(setLoginStateFalse())}>f</button> */}
    </div>
  )
}
////////////////////////////
// 登录状态 是否登录 组件
function AuthStatus() {
  const loginState = useSelector((state) => state.loginState.loginState)
  // const dispatch = useDispatch();
  // console.log(1300, '全局状态:登录状态:', loginState);
  // console.log(1340, '登录的用户名称:', get_LS_Item('account_name'))
  return (
      loginState ?
      <NavLink to={'/userinfo'}>{get_LS_Item('account_name')}</NavLink> :
      <NavLink to={'/login'}>登录|注册</NavLink>
  )
}
// 注销 按钮 组件
function Logout() {
  const loginState = useSelector((state) => state.loginState.loginState)
  const dispatch = useDispatch();
  // console.log(1300, '全局状态:登录状态:', loginState);
  //
  function handleLogout() {
    // console.log(1301, '注销');
    localStorage.removeItem('account_name');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('access_token');
    localStorage.setItem('account_LoginTime', 0*1);
    dispatch(setLoginStateFalse())
    dispatch(setLoginStamp(0))
    // console.log(1310, '已清除登录信息');
    // console.log(1320, '全局状态:登录状态:', loginState);
  }
  if (loginState) {
    return (
      // 已登录
      <>
        {loginState && <NavLink to={'/login'} replace={true} onClick={handleLogout}>注销</NavLink>}
      </>
    )
  }
  return false;
}
